import { styled } from '@linaria/react';

import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const MethodHeading = styled.h4`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const MethodRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
`;

export const MethodOption = styled.label`
  display: flex;
  align-items: center;
  gap: ${space[3]};
  padding: ${space[4]};
  border: 1px solid ${semantic.border.default};
  border-radius: ${layout.borderRadiusMd};
  background: ${colors.white};
  cursor: pointer;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};

  &[data-selected='true'] {
    border-color: ${semantic.border.selected};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const MethodIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  flex-shrink: 0;
`;

export const MethodLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${space[2]};
  flex: 1;
`;

export const MethodPrice = styled.span`
  margin-left: auto;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const Radio = styled.input`
  appearance: none;
  margin: 0;
  width: 16px;
  height: 16px;
  border: 1px solid ${semantic.border.default};
  border-radius: 50%;
  cursor: inherit;
  background: ${colors.white};
  flex-shrink: 0;

  &:checked {
    border-color: ${semantic.border.selected};
    background: ${semantic.border.selected};
    box-shadow: inset 0 0 0 3px ${colors.white};
  }
`;

export const MessageBox = styled.div`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.secondary};
`;

export const CostRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[3]} ${space[4]};
  background: ${semantic.bg.surfaceSubtle};
  border-radius: ${layout.borderRadius};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  color: ${semantic.text.primary};
`;
